import { render, staticRenderFns } from "./OrganizationMenus.vue?vue&type=template&id=0c542210&"
import script from "./OrganizationMenus.vue?vue&type=script&lang=js&"
export * from "./OrganizationMenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports